import { Injectable } from '@angular/core';
import { createAction, props } from '@ngrx/store';

@Injectable()
export class ReasonsSettingsActions {
    static getRemindersReasons = createAction('[Reminders:Reason] Get Reasons', props<{ userId: number }>());

    static getRemindersReasonsSuccess = createAction('[Reminders:Reason] Get Reasons Success',
        props<{ payload: any }>());

    static getRemindersReasonsFail = createAction('[Reminders:Reason] Get Reasons Fail',
        props<{ error: any }>());

    static saveRemindersReasonsSuccess = createAction('[Reminders:Reason] Save Reasons Success',
        props<{ payload: any }>());

    static saveRemindersReasonsFail = createAction('[Reminders:Reason] Save Reasons Fail',
        props<{ error: any, reasonId: any, strategyId: any }>());

    static openConfirmDialog = createAction(
        '[Reminders:Reason] Open Confirm Dialog',
        props<{dialogMessage: string, editedReasonId: any, editedStrategyId: any, okLabel: string, cancelLabel: string}>()
    );

    static openConfirmDialogCancel = createAction(
        '[Reminders:Reason] Open Confirm Dialog Cancelled');

    static saveRemindersReasons = createAction('[Reminders:Reason] Save Reasons' , props <{testCount: boolean, reasonId: any, strategyId: any}>());

}
